"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponReceiveRequest = void 0;
var CouponReceiveRequest = /** @class */ (function () {
    function CouponReceiveRequest() {
    }
    return CouponReceiveRequest;
}());
exports.CouponReceiveRequest = CouponReceiveRequest;
;
//# sourceMappingURL=couponReceive.request.js.map